<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <i style="    font-size: 30px;color: white;" class="fa fa-user"></i>
    </template>\
    <template slot="dropdown">
      <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods:{
    logout(){
      localStorage.clear();
      window.location = "#/"
    }
  }
}
</script>
